import axiosInstance from './axiosInstance';

export const getMyFastrackNodes = () => axiosInstance.get('/fastrack/my-nodes');
export const getMyFastrackNodesByPlan = (planId) => axiosInstance.get(`/fastrack/my-nodes/${planId}`);
